<template>
  <div class="table-wrapper">
    <div class="d-flex justify-content-between flex-wrap">
      <div class="restreams-main">
        <!-- TODO: Change these to restreams permissions when added -->
        <b-button
          v-if="$can('create', 'hubs', 'encoder')"
          variant="bg-primary"
          class="mb-sm-0 mb-1"
          :disabled="loading"
          @click="onCreateRestream"
        >
          <GjIcon
            class="icon-left"
            name="Plus"
          />
          Add new Restream
        </b-button>
      </div>
      <div>
        <!-- TODO: Change these to restreams permissions when added -->
        <b-button
          v-if="$can('list', 'hubs', 'encoder')"
          variant="bg-white"
          class="mr-0"
          :disabled="loading"
          @click="fetchRestreams"
        >
          <GjIcon
            class="icon-left"
            name="Refresh"
          />
          Refresh
        </b-button>
      </div>
    </div>

    <div class="default-table">
      <div class="position-relative d-none d-lg-block">
        <b-table
          ref="table"
          :items="restreams"
          :fields="fields"
          :class="{ loaded: !loading }"
          show-empty
          responsive
          :busy="loading"
        >
          <template #cell(serverURL)="data">
            {{ splitUrl(data.item.serverURL).url }}
          </template>
          <template #cell(key)="data">
            <text-hidden
              :show-password="showServerKey"
              :text="splitUrl(data.item.serverURL).key"
              white-background
              :hide-copy-icon="true"
              @toggle="showServerKey = !showServerKey"
            />
          </template>
          <template #cell(status)="data">
            <div class="custom-options d-flex">
              <div
                class="custom-size"
                :style="{ backgroundColor: data.item.stats.status ? 'green' : 'red'}"
              />
              <div
                class="d-flex flex-column"
              >
                <p class="text-secondary">
                  {{ data.item.stats.status ? 'Running' : 'Pending' }}
                </p>
              </div>
            </div>
          </template>
          <template #cell(activate)="data">
            <b-form-checkbox
              :checked="!data.item.disabled"
              name="check-button"
              class="status-button"
              switch
              inline
              @change="onToggle(data.item)"
            />
          </template>
          <template #cell(actions)="data">
            <b-button
              v-if="$can('delete', 'hubs', 'encoder')"
              variant="bg-secondary"
              class="mb-sm-0 mb-1"
              @click="onDelete(data.item)"
            >
              <GjIcon
                name="Delete"
                class="delete-icon"
                size="29"
              />
            </b-button>
          </template>

          <template #empty>
            <template v-if="fetchingRestreams">
              <div class="loading-table text-center py-3">
                <b-spinner variant="primary" />
              </div>
            </template>
            <template v-else>
              <no-data
                no-data-text="No restreams have been added yet..."
                create-text="+ Create a restream"
                access-page="Restreams"
                icon="Section"
                :has-permissions="hasPermissions"
                @action="$router.push({ name: 'restreams-create' })"
              />
            </template>
          </template>
        </b-table>
        <table-busy v-if="fetchingRestreams && restreams && restreams.length > 0" />
      </div>
    </div>
    <create-form
      v-if="showCreateForm"
      @close="showCreateForm = false"
      @submit="addRestream"
    />
  </div>
</template>
<script>
import CreateForm from './CreateRestream.vue'
import TextHidden from '@/components/text/TextHidden.vue'

export default {
  name: 'Restreams',
  components: { CreateForm, TextHidden },
  data() {
    return {
      fields: [
        {
          key: 'serverURL',
          label: 'URL',
          isPrimary: true,
        },
        { key: 'key', label: 'Key', isPrimary: true },
        { key: 'status', label: 'Status' },
        { key: 'activate', label: 'Activate' },
        { key: 'actions', label: 'Actions', variant: 'small' },
      ],
      currentPage: 1,
      hasPermissions: true,
      showCreateForm: false,
      showServerKey: false,
    }
  },
  computed: {
    resultInfo() {
      return this.$store.state.restreams.resultInfo
    },
    restreams() {
      return this.$store.state.restreams.restreams
    },
    fetchingRestreams() {
      return this.$store.state.restreams.fetchingRestreams
    },
    creatingRestream() {
      return this.$store.state.restreams.creatingRestream
    },
    updatingRestream() {
      return this.$store.state.restreams.updatingRestream
    },
    removingRestream() {
      return this.$store.state.restreams.removingRestream
    },
    loading() {
      return this.fetchingRestreams || this.creatingRestream || this.updatingRestream || this.removingRestream
    },
    liveHubName() {
      return this.$route.params.liveHubName
    },
  },
  created() {
    this.fetchRestreams()
  },
  methods: {
    onCreateRestream() {
      this.showCreateForm = true
    },
    onToggle(data) {
      this.toggleRestream(this.liveHubName, data.serverURL)
    },
    onDelete(data) {
      this.deleteRestream(this.liveHubName, data.serverURL)
    },
    addRestream(data) {
      this.createRestream(this.liveHubName, data.serverURL, data.serverKey)
    },
    splitUrl(inputString) {
      const lastSlashIndex = inputString.lastIndexOf('/')
      return lastSlashIndex !== -1
        ? { url: inputString.slice(0, lastSlashIndex), key: inputString.slice(lastSlashIndex + 1) }
        : { url: inputString, key: '' }
    },
    fetchRestreams() {
      this.$store
        .dispatch('restreams/fetchRestreams', this.liveHubName)
        .catch(error => {
          if (error.response?.status === 403) {
            this.hasPermissions = false
            return
          }
          this.errorToast('Something went wrong')
        })
    },
    createRestream(liveHubName, serverURL, serverKey) {
      const query = { liveHubName, restream: { serverURL, serverKey } }
      this.$store
        .dispatch('restreams/createRestream', query)
        .then(() => {
          this.showCreateForm = false
          this.fetchRestreams()
        })
        .catch(error => {
          if (error.response?.status === 403) {
            this.hasPermissions = false
            return
          }
          this.errorToast('Something went wrong')
        })
    },
    toggleRestream(liveHubName, serverURL) {
      const query = { liveHubName, serverURL }
      this.$store
        .dispatch('restreams/toggleRestream', query)
        .then(() => this.fetchRestreams())
        .catch(error => {
          if (error.response?.status === 403) {
            this.hasPermissions = false
            return
          }
          this.errorToast('Something went wrong')
        })
    },
    deleteRestream(liveHubName, serverURL) {
      this.confirmDelete(
        'Delete Restream',
        'Are you sure you want to delete this restream?',
        'Delete',
      ).then(ok => {
        if (ok) {
          const query = { liveHubName, serverURL }
          this.$store
            .dispatch('restreams/removeRestream', query)
            .then(() => {
              this.successToast('Restream deleted successfully')
              this.fetchRestreams()
            })
            .catch(error => {
              const message = error.response?.data?.Message
              this.errorToast(message || 'An error occurred deleting restream.')
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped >

.custom-size {
  width: 8px;
  height: 8px;
  border-radius: 10px;
  margin-top: 8px;
  margin-right: 10px;
}

.status-button{
  margin-top: -25px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.delete-icon {
  &:hover{
    cursor: pointer;
  }
}
</style>
